export const SETS_SET = "SETS::SET";
export const TAGS_SET = "TAGS::SET";
export const COMPRESS_SET = "COMPRESS::SET";
